<template>
    <div class="search-index">
        <div class="logo-img">
            <img src="https://www1.pcauto.com.cn/2014/kuaisou/images/indexLogo.png" alt="" />
        </div>
        <div class="navs-warp">
            <div class="nav-title">
                <a href="javascript:;" v-for=" (nav,index) in $global.tabLists" :key="index" :class="{active:isActiveId == nav.id}" @click="tabchang(nav)">{{nav.text}}</a>
            </div>
        </div>
        <div class="search-box">
            <input type="text" ref="inputBox"  class="input-box" @keydown.enter="getComposite(keyWord)" @blur="cancle" v-model="keyWord" @focus="reqLenovoWord" @keyup="reqLenovoWord">
            <button class="search-btn" @click="getComposite(keyWord)">搜索</button>
              <el-collapse-transition>
                <div class="Lenovo-word" v-if="isShow">
                    <p class="p-top">↓点击直达车系频道</p>
                    <ul>
                        <li v-for="(lenovo,index) in lenovoLists" :key="index" @click="lenovoSearch(lenovo)"><span class="cars-name">{{lenovo.keyword}}</span><span class="cars-price">{{lenovo.price}}</span></li>
                    </ul>
                    <p class="p-bottom" @click="isShow=false">关闭</p>
                </div>
              </el-collapse-transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Search',
        data() {
            return {
                keyWord: '', // 搜索关键词
                isShow: false, //是否显示联想词
                lenovoLists: [], //联想词
				isActiveId : 1,
            }
        },
        methods: {
            cancle() { //失去焦点时取消联想词
                setTimeout(()=>{
                    this.isShow =false
                },101)
            },
            //切换tab
            tabchang(item) {
                this.isActiveId = item.id
                this.$global.tab = item
                if(item.title === 'auto_index') {
                    this.countAd(4507)
                }else if(item.title === 'auto_cms') {
                    this.countAd(4508)
                }else if(item.title === 'auto_bbs') {
                    this.countAd(4509)
                }else if(item.title === 'auto_video') {
                    this.countAd(4510)
                }else if(item.title === 'auto_baike') {
                    this.countAd(4511)
                }else if(item.title === 'picture') {
                    this.countAd(4512)
                }else if(item.title === 'dealers') {
                    this.countAd(4513)
                }else if(item.title === 'carQa') {
                    this.countAd(4514)
                }else if(item.title === 'auto_hj') {
                    this.countAd(4515)
                }
            },
            //请求联想词数据
            async reqLenovoWord() {
                this.$global.q = this.keyWord
                try {
                    if(this.keyWord) {
                        const res = await this.fetCompletion({q:this.keyWord})
                        if(res.length > 0) {
                            this.isShow = true
                        }else {
                            this.isShow = false
                        }
                        this.lenovoLists = res
                    }else {
                        this.isShow = false
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //搜索输入的关键词
            async getComposite(word) {
                try {
                    const res = await this.fetType({q:word})
                    let type = res.type
                    let id = res.id
                    let city = res.rid
                    if(word) {
                        this.$global.q = word
                        let tab = this.$global.tab
                        this.keyWord = ''
                        if(tab.title === 'picture' ) {
                            if(type === 3) {
                               window.location.href = window.encodeURI(`https://price.pcauto.com.cn/cars/sg${id}/#ad=5251`)
                            }else if(type === 2) {
                               window.location.href = window.encodeURI(`https://price.pcauto.com.cn/cars/b${id}/`)
                            }else if(type === 1) {
                               window.location.href = window.encodeURI(`https://price.pcauto.com.cn/cars/nb${id}/`)
                            }else {
                               window.location.href = window.encodeURI(`https://price.pcauto.com.cn/cars/common/auto_notfound?qtext=${word}&t=2#ad=4554`)
                            }
                        }else if(tab.title === 'dealers' ) {
                            if(type ===3) {
                               window.location.href = window.encodeURI(`https://price.pcauto.com.cn/shangjia/c${city}/sg${id}/`)
                            }else if(type === 2) {
                               window.location.href = window.encodeURI(`https://price.pcauto.com.cn/shangjia/c${city}/b${id}/`)
                            }else if(type === 1) {
                               window.location.href = window.encodeURI(`https://price.pcauto.com.cn/shangjia/c${city}/nb${id}/`)
                            }else {
                               window.location.href = window.encodeURI(`https://price.pcauto.com.cn/shangjia/`)
                            }
                        }else if(tab.title === 'carQa' ) window.location.href =  window.encodeURI(`https://www.pcauto.com.cn/wd/search/${word}/`)
                            else {
                                this.keyWord = ''
                                this.$EventBus.$emit('showContent')
                                // window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?q=${this.$global.q}&${tab.title}=true`)
                                window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?tab=${tab.title}&q=${this.$global.q}`)
                            }
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //联想词搜索
            lenovoSearch(item) {
                let inputBox = this.$refs.inputBox
                if(inputBox) {
                    inputBox.blur()
                    this.isShow = false
                }
                if(item.isSerialGroup) {
                    window.open(`https://price.pcauto.com.cn/sg${item.sid}/#ad=5439`)
                }else if(item.isFactory) {
                    // window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?q=${item.keyword}&${this.$global.tab.title}=true`)
                    window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?tab=${this.$global.tab.title}&q=${item.keyword}`)
                }else if(item.isBrand) {
                    // window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?q=${item.keyword}&${this.$global.tab.title}=true`)
                    window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?tab=${this.$global.tab.title}&q=${item.keyword}`)
                }
            }
        },
        mounted() {
            this.isActiveId = this.$global.tab.id
            this.countAd(12104)
        }
    }
</script>

<style lang="scss" scoped>
.search-index {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    padding-top: 115px;
    box-sizing: border-box;
    .logo-img {
        text-align: center;
    }
    .navs-warp {
        margin-top: 40px;
        .nav-title {
            width: 620px;
            margin: 0 auto;
            a {
                display: inline-block;
                color: #333333;
                padding: 0 8px;
                font-size: 14px;
                &.active {
                    color: #ff9900;
                    font-weight: 600;
                }
            }
        }
    }
    .search-box {
        display: flex;
        height: 30px;
        margin-top: 6px;
        position: relative;
        width: 620px;
        margin: 0 auto;
        margin-top: 10px;
        .input-box {
            padding-left: 5px;
            flex: 1;
            box-shadow: #afafaf 1px 1px 1px inset;
            border: 1px #e0e0e0 solid;
            box-sizing: border-box;
            &:focus {
                border: 1px solid #000000;
            }
        }
        .search-btn {
            width: 75px;
            height: 100%;
            font-size: 16px;
            color: #ffffff;
            background-color: #ff9900;
            cursor: pointer;
        }
        .Lenovo-word {
            position: absolute;
            width: calc(100% - 75px);
            top: 30px;
            background-color: #ffffff;
            z-index: 88;
            font-size: 14px;
            border: 1px solid #777777;
            box-sizing: border-box;
            .p-top {
                color: #225599;
                padding: 0 5px;
                line-height: 25px;
                border-bottom: 1px dashed #777777;
                font-family: "";
                font-size: 12px;
                line-height: 24px;
                height: 24px;
            }
            .p-bottom {
                line-height: 25px;
                font-size: 14px;
                background-color: #f5f5f5;
                text-align: right;
                padding-right: 5px;
                cursor: pointer;
            }
            ul {
                .cars-name {
                    color: #777777;
                }
                .cars-price {
                    color: #cc0000;
                }
                li {
                    line-height: 24px;
                    padding: 0 5px;
                    cursor: pointer;
                    display: flex;
                    justify-content: space-between;
                    &:hover {
                        background-color: #ffedca;
                    }
                }
            }
        }
    }
}
</style>